'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.BlockDriver = /*#__PURE__*/function () {
  function BlockDriver() {
    (0, _classCallCheck2["default"])(this, BlockDriver);
  }
  return (0, _createClass2["default"])(BlockDriver, [{
    key: "convert",
    value: function convert() {
      var time = new Date();
      for (var blockType in Entry.block) {
        if (typeof Entry.block[blockType] === 'function') {
          this._convertBlock(blockType);
        }
      }
      console.log(new Date().getTime() - time.getTime());
    }
  }, {
    key: "_convertBlock",
    value: function _convertBlock(blockType) {
      var blocklyInfo = Blockly.Blocks[blockType];
      var blockInfo = EntryStatic.blockInfo[blockType];
      var className;
      var isNotFor;
      if (blockInfo) {
        className = blockInfo["class"];
        isNotFor = blockInfo.isNotFor;

        //add block definition by xml to json
        var xml = blockInfo.xml;
        if (xml) {
          xml = $.parseXML(xml);
          var child = xml.childNodes[0];
          var def = generateBlockDef(child);
        }
      }
      var mockup = new Entry.BlockMockup(blocklyInfo, def, blockType);
      var blockObject = mockup.toJSON();
      blockObject["class"] = className;
      blockObject.isNotFor = isNotFor;
      if (_.isEmpty(blockObject.paramsKeyMap)) {
        delete blockObject.paramsKeyMap;
      }
      if (_.isEmpty(blockObject.statementsKeyMap)) {
        delete blockObject.statementsKeyMap;
      }
      blockObject.func = Entry.block[blockType];
      var PRIMITIVES = ['NUMBER', 'TRUE', 'FALSE', 'TEXT', 'FUNCTION_PARAM_BOOLEAN', 'FUNCTION_PARAM_STRING', 'TRUE_UN'];
      if (PRIMITIVES.indexOf(blockType.toUpperCase()) > -1) {
        blockObject.isPrimitive = true;
      }
      Entry.block[blockType] = blockObject;
      function generateBlockDef(block) {
        var def = {
          type: block.getAttribute('type'),
          index: {}
        };
        var children = $(block).children();
        if (!children) {
          return def;
        }
        for (var i = 0; i < children.length; i++) {
          var _child = children[i];
          var tagName = _child.tagName;
          var subChild = $(_child).children()[0];
          var key = _child.getAttribute('name');
          if (tagName === 'value') {
            if (subChild.nodeName == 'block') {
              if (!def.params) {
                def.params = [];
              }
              def.params.push(generateBlockDef(subChild));
              def.index[key] = def.params.length - 1;
            }
          } else if (tagName === 'field') {
            if (!def.params) {
              def.params = [];
            }
            def.params.push(_child.textContent);
            def.index[key] = def.params.length - 1;
          }
        }
        return def;
      }
    }
  }]);
}();
Entry.BlockMockup = /*#__PURE__*/function () {
  function BlockMockup(blocklyInfo, def, blockType) {
    (0, _classCallCheck2["default"])(this, BlockMockup);
    this.templates = [];
    this.params = [];
    this.statements = [];
    this.color = '';
    this.isPrev = false;
    this.isNext = false;
    this.output = false;
    this.fieldCount = 0;
    this.events = {};
    this.def = def || {};
    this.paramsKeyMap = {};
    this.statementsKeyMap = {};
    this.definition = {
      params: [],
      type: this.def.type
    };
    this.simulate(blocklyInfo);
    this.def = this.definition;
  }
  return (0, _createClass2["default"])(BlockMockup, [{
    key: "simulate",
    value: function simulate(blocklyInfo) {
      if (blocklyInfo.sensorList) {
        this.sensorList = blocklyInfo.sensorList;
      }
      if (blocklyInfo.portList) {
        this.portList = blocklyInfo.portList;
      }
      blocklyInfo.init.call(this);
      if (blocklyInfo.whenAdd) {
        if (!this.events.blockViewAdd) {
          this.events.blockViewAdd = [];
        }
        this.events.blockViewAdd.push(blocklyInfo.whenAdd);
      }
      if (blocklyInfo.whenRemove) {
        if (!this.events.blockViewDestroy) {
          this.events.blockViewDestroy = [];
        }
        this.events.blockViewDestroy.push(blocklyInfo.whenRemove);
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var skeleton = '';
      if (this.output) {
        if (this.output === 'Boolean') {
          skeleton = 'basic_boolean_field';
        } else {
          skeleton = 'basic_string_field';
        }
      } else if (!this.isPrev && this.isNext) {
        skeleton = 'basic_event';
      } else if (this.statements.length == 1) {
        skeleton = 'basic_loop';
      } else if (this.statements.length == 2) {
        skeleton = 'basic_double_loop';
      } else if (this.isPrev && this.isNext) {
        skeleton = 'basic';
      } else if (this.isPrev && !this.isNext) {
        skeleton = 'basic_without_next';
      }
      var def = this.def;
      removeIndex(def);
      function removeIndex(def) {
        if (!def) {
          return;
        }
        var params = def.params;
        if (!params) {
          return;
        }
        for (var i = 0; i < params.length; i++) {
          var param = params[i];
          if (!param) {
            continue;
          }
          delete param.index;
          removeIndex(param);
        }
      }
      var reg = /dummy_/im;
      for (var key in this.paramsKeyMap) {
        if (reg.test(key)) {
          delete this.paramsKeyMap[key];
        }
      }
      for (key in this.statementsKeyMap) {
        if (reg.test(key)) {
          delete this.statementsKeyMap[key];
        }
      }
      return {
        color: this.color,
        skeleton: skeleton,
        statements: this.statements,
        template: this.templates.filter(function (p) {
          return typeof p === 'string';
        }).join(' '),
        params: this.params,
        events: this.events,
        def: this.def,
        paramsKeyMap: this.paramsKeyMap,
        statementsKeyMap: this.statementsKeyMap
      };
    }
  }, {
    key: "appendDummyInput",
    value: function appendDummyInput() {
      return this;
    }
  }, {
    key: "appendValueInput",
    value: function appendValueInput(key) {
      // field block
      if (this.def && this.def.index) {
        if (this.def.index[key] !== undefined) {
          this.definition.params.push(this.def.params[this.def.index[key]]);
        } else {
          this.definition.params.push(null);
        }
      }
      this.params.push({
        type: 'Block',
        accept: 'string'
      });
      this._addToParamsKeyMap(key);
      this.templates.push(this.getFieldCount());
      return this;
    }
  }, {
    key: "appendStatementInput",
    value: function appendStatementInput(key) {
      var statement = {
        accept: 'basic'
      };
      this._addToStatementsKeyMap(key);
      this.statements.push(statement);
    }
  }, {
    key: "setCheck",
    value: function setCheck(accept) {
      //add value
      var params = this.params;
      if (accept === 'Boolean') {
        params[params.length - 1].accept = 'boolean';
      }
    }
  }, {
    key: "appendField",
    value: function appendField(field, opt) {
      if (!field) {
        return this;
      }
      if (typeof field === 'string' && field.length > 0) {
        if (opt) {
          field = {
            type: 'Text',
            text: field,
            color: opt
          };
          this.params.push(field);
          this._addToParamsKeyMap();
          this.templates.push(this.getFieldCount());
          if (this.def && this.def.index && this.def.index[opt] !== undefined) {
            this.definition.params.push(this.def.params[this.def.index[opt]]);
          } else {
            this.definition.params.push(undefined);
          }
        } else {
          this.templates.push(field);
        }
      } else {
        if (field.constructor == Blockly.FieldIcon) {
          if (field.type === 'start') {
            this.params.push({
              type: 'Indicator',
              img: field.src_,
              size: 17,
              position: {
                x: 0,
                y: -2
              }
            });
          } else {
            this.params.push({
              type: 'Indicator',
              img: field.src_,
              size: 12
            });
          }
          this._addToParamsKeyMap();
          this.templates.push(this.getFieldCount());
          if (this.definition) {
            this.definition.params.push(null);
          }
        } else if (field.constructor == Blockly.FieldDropdown) {
          this.params.push({
            type: 'Dropdown',
            options: field.menuGenerator_,
            value: field.menuGenerator_[0][1],
            fontSize: 11
          });
          this._addToParamsKeyMap(opt);
          this.templates.push(this.getFieldCount());
          if (this.def && this.def.index && this.def.index[opt] !== undefined) {
            this.definition.params.push(this.def.params[this.def.index[opt]]);
          } else {
            this.definition.params.push(undefined);
          }
        } else if (field.constructor == Blockly.FieldDropdownDynamic) {
          this.params.push({
            type: 'DropdownDynamic',
            value: null,
            menuName: field.menuName_,
            fontSize: 11
          });
          this.templates.push(this.getFieldCount());
          if (this.def && this.def.index && this.def.index[opt] !== undefined) {
            this.definition.params.push(this.def.params[this.def.index[opt]]);
          } else {
            this.definition.params.push(undefined);
          }
          this._addToParamsKeyMap(opt);
        } else if (field.constructor == Blockly.FieldTextInput) {
          this.params.push({
            type: 'TextInput',
            value: 10
          });
          this.templates.push(this.getFieldCount());
          this._addToParamsKeyMap(opt);
        } else if (field.constructor == Blockly.FieldAngle) {
          this.params.push({
            type: 'Angle'
          });
          this.templates.push(this.getFieldCount());
          if (this.def && this.def.index && this.def.index[opt] !== undefined) {
            this.definition.params.push(this.def.params[this.def.index[opt]]);
          } else {
            this.definition.params.push(null);
          }
          this._addToParamsKeyMap(opt);
        } else if (field.constructor == Blockly.FieldKeydownInput) {
          this.params.push({
            type: 'Keyboard',
            value: 81
          });
          this.templates.push(this.getFieldCount());
          if (this.def.index[opt] !== undefined) {
            this.definition.params.push(this.def.params[this.def.index[opt]]);
          } else {
            this.definition.params.push(undefined);
          }
          this._addToParamsKeyMap(opt);
        } else if (field.constructor == Blockly.FieldColour) {
          this.params.push({
            type: 'Color'
          });
          this.templates.push(this.getFieldCount());
          this._addToParamsKeyMap(opt);
        } else {
          console.log('else', field);
          //console.log('else', field);
        }
      }
      return this;
    }
  }, {
    key: "setColour",
    value: function setColour(color) {
      this.color = color;
    }
  }, {
    key: "setInputsInline",
    value: function setInputsInline() {}
  }, {
    key: "setOutput",
    value: function setOutput(bool, type) {
      if (!bool) {
        return;
      }
      this.output = type;
    }
  }, {
    key: "setPreviousStatement",
    value: function setPreviousStatement(bool) {
      this.isPrev = bool;
    }
  }, {
    key: "setNextStatement",
    value: function setNextStatement(bool) {
      this.isNext = bool;
    }
  }, {
    key: "setEditable",
    value: function setEditable(bool) {
      // Not implemented
    }
  }, {
    key: "getFieldCount",
    value: function getFieldCount() {
      this.fieldCount++;
      return "%".concat(this.fieldCount);
    }
  }, {
    key: "_addToParamsKeyMap",
    value: function _addToParamsKeyMap(key) {
      key = key ? key : "dummy_".concat(Entry.Utils.generateId());
      var map = this.paramsKeyMap;
      map[key] = Object.keys(map).length;
    }
  }, {
    key: "_addToStatementsKeyMap",
    value: function _addToStatementsKeyMap(key) {
      key = key ? key : "dummy_".concat(Entry.Utils.generateId());
      var map = this.statementsKeyMap;
      map[key] = Object.keys(map).length;
    }
  }]);
}();